var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.744 245.743C193.362 246.864 220.72 252.141 229.206 264.278C218.344 262.456 193.335 262.008 180.19 274.789",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348.062 245.743C335.444 246.864 308.086 252.141 299.601 264.278C310.462 262.456 335.472 262.008 348.617 274.789",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.394 207.806C90.26 181.101 97.915 121.992 108.394 114.387C118.872 106.781 167.947 136.593 185.982 173.064",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M421.364 207.806C439.498 181.101 431.843 121.992 421.364 114.387C410.886 106.781 361.811 136.593 343.776 173.064",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.18 320.564L91.874 299.198",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.759 365.027L94.9268 370.956",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M360.472 320.564L436.778 299.198",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M364.893 365.027L433.726 370.956",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.344 314.839C267.921 302.968 247.844 308.79 237.755 314.764C236.074 315.759 236.041 318.075 237.593 319.263C245.953 325.659 258.525 334.268 263.675 334.268C270.023 334.268 282.252 325.559 289.727 319.469C291.279 318.205 291.095 315.809 289.344 314.839Z",
    fill: "#1C1B1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.675 330.65V352.364L232.897 371.182",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M264.507 330.65V352.364L295.284 371.182",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 140,
    width: 151,
    height: 65,
    rx: 16,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.892 54C219.786 56.7826 243.276 68.3478 222.733 83.2174C209.471 91.3043 210.043 104.4 222.733 114",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.892 54C266.786 56.7826 290.276 68.3478 269.733 83.2174C256.471 91.3043 257.043 104.4 269.733 114",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M307.892 54C313.786 56.7826 337.276 68.3478 316.733 83.2174C303.471 91.3043 304.043 104.4 316.733 114",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M375.755 240.655C380.16 217.756 398.389 199.888 406.953 193.816C434.848 202.143 441.414 228.512 441.21 240.655C443.657 275.524 418.168 280.338 405.118 278.386C376.734 274.743 373.716 251.714 375.755 240.655Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_10917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 173,
    width: 114,
    height: 121
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 354.5,
    y: 175.5,
    width: 108.781,
    height: 116,
    fill: "#D9D9D9",
    stroke: "#1C1B1F",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_10917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.188 247.153C391.213 253.237 393.784 257.909 398.257 260.546C402.201 262.871 406.145 264.022 410.028 263.721C410.488 263.686 410.653 263.797 410.793 263.938C410.959 264.105 411.131 264.375 411.131 265.01C411.131 265.402 411.024 265.645 410.802 265.881C410.543 266.157 410.302 266.267 409.995 266.299C405.584 266.584 401.11 265.316 396.516 262.291C392.274 259.499 389.384 254.746 388.122 247.562L388.117 247.531L388.11 247.5C388.01 247.003 388.103 246.741 388.317 246.475C388.567 246.165 388.768 246.083 389.097 246.083C389.342 246.083 389.531 246.145 389.761 246.346C389.977 246.535 390.121 246.765 390.188 247.153ZM390.188 247.153C390.188 247.151 390.187 247.15 390.187 247.149L392.652 246.734M390.188 247.153C390.188 247.153 390.188 247.154 390.188 247.155L392.652 246.734M392.652 246.734C393.601 252.364 395.892 256.25 399.527 258.393C403.161 260.535 406.599 261.481 409.838 261.229L385.66 247.994C385.423 246.818 385.66 245.788 386.371 244.906C387.082 244.024 387.991 243.583 389.097 243.583C389.966 243.583 390.736 243.877 391.408 244.465C392.08 245.053 392.494 245.809 392.652 246.734ZM405.858 189.319L405.916 189.264L405.97 189.207C406.343 188.81 406.741 188.556 407.177 188.401C407.742 188.201 408.309 188.104 408.89 188.104C409.471 188.104 410.038 188.201 410.603 188.401C411.039 188.556 411.437 188.81 411.81 189.207L411.864 189.264L411.922 189.319C415.186 192.377 418.738 195.987 422.578 200.154C426.37 204.269 429.893 208.674 433.147 213.37C436.371 218.024 439.053 222.874 441.197 227.922C443.29 232.85 444.317 237.729 444.317 242.574C444.317 253.78 440.893 262.989 434.128 270.38C427.378 277.755 419.022 281.416 408.89 281.416C398.758 281.416 390.402 277.755 383.652 270.38C376.887 262.989 373.463 253.78 373.463 242.574C373.463 237.729 374.49 232.85 376.583 227.922C378.726 222.874 381.409 218.024 384.633 213.37C387.887 208.674 391.41 204.269 395.202 200.154C399.042 195.987 402.594 192.377 405.858 189.319ZM410.634 194.652L408.89 192.953L407.146 194.652C397.655 203.897 390.413 212.5 385.489 220.463C380.574 228.41 377.945 235.803 377.945 242.574C377.945 252.103 380.81 260.184 386.652 266.626C392.514 273.089 399.989 276.333 408.89 276.333C417.791 276.333 425.266 273.089 431.128 266.626C436.97 260.184 439.835 252.103 439.835 242.574C439.835 235.803 437.206 228.41 432.291 220.463C427.367 212.5 420.125 203.897 410.634 194.652Z",
    fill: "#1C1B1F",
    stroke: "#1C1B1F",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/고양이고질병_none.448a7503822875db0538f10d76e2b44c.svg";
export { ForwardRef as ReactComponent };